var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUseCases2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 144,
    viewBox: "0 0 228 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 228,
    height: 144,
    rx: 20,
    fill: "#ECFFFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.74 114H27.82V126H25.74V114ZM35.96 126H33.9V114H35.96V126ZM34.48 120.94H27.16V119.16H34.48V120.94ZM40.7509 114H48.3909V115.68H40.7509V114ZM40.6509 124.32H48.3509V126H40.6509V124.32ZM40.6109 120.74V119.06H47.7509V120.74H40.6109ZM41.9309 126H39.8509V114H41.9309V126ZM56.7977 115.58H55.1377L55.7777 114.5C55.671 114.98 55.531 115.52 55.3577 116.12C55.1977 116.707 55.0243 117.313 54.8377 117.94C54.651 118.553 54.4643 119.16 54.2777 119.76L52.2777 126H50.1377L54.3577 114H57.5977L61.8177 126H59.6177L57.5977 119.76C57.411 119.16 57.2243 118.547 57.0377 117.92C56.851 117.293 56.6843 116.68 56.5377 116.08C56.391 115.48 56.271 114.953 56.1777 114.5L56.7977 115.58ZM59.1777 122.76H52.6577V121.34H59.1777V122.76ZM65.8656 126V124.24H71.7856V126H65.8656ZM66.2856 114V126H64.2056V114H66.2856ZM71.9598 115.86V114H81.5798V115.86H71.9598ZM75.7198 114.22H77.7998V126H75.7198V114.22ZM84.2439 114H86.3239V126H84.2439V114ZM94.4639 126H92.4039V114H94.4639V126ZM92.9839 120.94H85.6639V119.16H92.9839V120.94ZM103.075 126.24C102.155 126.24 101.348 126.107 100.655 125.84C99.9748 125.573 99.4015 125.173 98.9348 124.64C98.4815 124.107 98.1415 123.453 97.9148 122.68C97.6882 121.893 97.5748 120.993 97.5748 119.98C97.5748 118.62 97.7882 117.48 98.2148 116.56C98.6548 115.64 99.2882 114.947 100.115 114.48C100.955 114 101.975 113.76 103.175 113.76C104.162 113.76 105.008 113.913 105.715 114.22C106.422 114.513 106.982 114.96 107.395 115.56C107.808 116.16 108.088 116.913 108.235 117.82L106.275 118.26C106.062 117.313 105.715 116.62 105.235 116.18C104.755 115.74 104.055 115.52 103.135 115.52C102.268 115.52 101.582 115.707 101.075 116.08C100.568 116.44 100.202 116.953 99.9748 117.62C99.7615 118.287 99.6548 119.073 99.6548 119.98C99.6548 120.953 99.7615 121.78 99.9748 122.46C100.202 123.127 100.568 123.64 101.075 124C101.582 124.347 102.248 124.52 103.075 124.52C103.755 124.52 104.308 124.42 104.735 124.22C105.175 124.02 105.522 123.72 105.775 123.32C106.028 122.907 106.235 122.38 106.395 121.74L108.335 122.14C108.188 123.047 107.902 123.807 107.475 124.42C107.062 125.02 106.488 125.473 105.755 125.78C105.022 126.087 104.128 126.24 103.075 126.24ZM116.454 115.58H114.794L115.434 114.5C115.327 114.98 115.187 115.52 115.014 116.12C114.854 116.707 114.681 117.313 114.494 117.94C114.307 118.553 114.121 119.16 113.934 119.76L111.934 126H109.794L114.014 114H117.254L121.474 126H119.274L117.254 119.76C117.067 119.16 116.881 118.547 116.694 117.92C116.507 117.293 116.341 116.68 116.194 116.08C116.047 115.48 115.927 114.953 115.834 114.5L116.454 115.58ZM118.834 122.76H112.314V121.34H118.834V122.76ZM130.062 120.74L133.822 125.6V126H131.522L127.982 120.8L130.062 120.74ZM125.002 115.68L125.942 114.54V126H123.862V114H128.622C129.675 114 130.542 114.14 131.222 114.42C131.902 114.687 132.402 115.093 132.722 115.64C133.055 116.187 133.222 116.88 133.222 117.72C133.222 118.547 133.042 119.253 132.682 119.84C132.322 120.427 131.795 120.873 131.102 121.18C130.409 121.473 129.575 121.62 128.602 121.62H125.042V119.96H128.442C129.335 119.96 130.009 119.793 130.462 119.46C130.929 119.113 131.162 118.547 131.162 117.76C131.162 117.253 131.075 116.847 130.902 116.54C130.729 116.233 130.442 116.013 130.042 115.88C129.642 115.747 129.095 115.68 128.402 115.68H125.002ZM137.467 114H145.107V115.68H137.467V114ZM137.367 124.32H145.067V126H137.367V124.32ZM137.327 120.74V119.06H144.467V120.74H137.327ZM138.647 126H136.567V114H138.647V126Z",
    fill: "#0F1936"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1355 52.5V36.25L46.0677 28.125L32 36.25V52.5L46.0677 60.625L60.1355 52.5Z",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1356 52.4995L46.0679 60.6245V44.3745L60.1356 36.2495V52.4995Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0677 44.375L32 52.5V36.25L46.0677 28.125V44.375Z",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0677 60.6245L32 52.4995V36.2495L46.0677 44.3745V60.6245Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1355 36.25L46.0677 44.375L32 36.25L46.0677 28.125L60.1355 36.25Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2034 76.875V60.625L60.1356 52.5L46.0679 60.625V76.875L60.1356 85L74.2034 76.875Z",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2035 76.875L60.1357 85V68.75L74.2035 60.625V76.875Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1356 68.75L46.0679 76.875V60.625L60.1356 52.5V68.75Z",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1356 85L46.0679 76.875V60.625L60.1356 68.75V85Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2034 60.625L60.1356 68.75L46.0679 60.625L60.1356 52.5L74.2034 60.625Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2034 60.625V44.375L60.1356 36.25L46.0679 44.375V60.625L60.1356 68.75L74.2034 60.625Z",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2035 60.625L60.1357 68.75V52.5L74.2035 44.375V60.625Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1356 52.5L46.0679 60.625V44.375L60.1356 36.25V52.5Z",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1356 68.75L46.0679 60.625V44.375L60.1356 52.5V68.75Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2034 44.375L60.1356 52.5L46.0679 44.375L60.1356 36.25L74.2034 44.375Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M88.271 68.75V52.5L74.2032 44.375L60.1355 52.5V68.75L74.2032 76.8555L88.271 68.75Z",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2711 68.75L74.2034 76.8555V60.625L88.2711 52.5V68.75Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2032 60.625L60.1355 68.75V52.5L74.2032 44.375V60.625Z",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M88.271 52.5L74.2032 60.625L60.1355 52.5L74.2032 44.375L88.271 52.5Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2034 44.375V28.125L60.1356 20L46.0679 28.125V44.375L60.1356 52.5L74.2034 44.375Z",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2032 44.375L60.1355 52.5V36.25L74.2032 28.125V44.375Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1356 36.25L46.0679 44.375V28.125L60.1356 20V36.25Z",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1355 84.9805L46.0677 76.8555V60.625L32 52.5V36.25L46.0677 44.375V28.125L60.1355 36.25V52.5L74.2032 60.625V76.875L60.1355 68.75V84.9805Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2034 28.125L60.1356 36.25L46.0679 28.125L60.1356 20L74.2034 28.125Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseCases2);
export default __webpack_public_path__ + "static/media/useCases2.d4607cfb7ab8e60e2146345b5a476163.svg";
export { ForwardRef as ReactComponent };